import FAIcon from 'FAIcon'

import PropTypes from 'prop-types'

import '../css/FICActionButton.css'
import React from 'react'

/*

PROPS:
- size: (default medium)
- icon: (default null)
- style
- onClick
- href

*/

function FICActionButton (props) {
  const className = 'fic-action-button fic-' + props.color + ' ' + props.size + (props.disabled ? ' fic-action-button-disabled' : '')
  return <a
    onClick={(event) => {
      if (props.onClick && !props.disabled) {
        props.onClick(event)
      }
      event.stopPropagation()
    }}
    onMouseOver={(event) => {
      if (props.onMouseOver) { props.onMouseOver(event) }
    }}
    onMouseOut={(event) => {
      if (props.onMouseOut) { props.onMouseOut(event) }
    }}
    href={props.href}
    target={props.target}
    title={props.title}
  >
    <FAIcon
      name={props.icon}
      className={className}
      style={props.style}
      fixedWidth={props.fixedWidth}
    />
  </a>
}

FICActionButton.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  href: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  style: PropTypes.object,
  fixedWidth: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  disabled: PropTypes.bool
}

FICActionButton.defaultProps = {
  color: 'gray',
  size: 'large',
  href: undefined,
  target: undefined,
  icon: undefined,
  title: undefined,
  fixedWidth: false,
  disabled: false
}

export default FICActionButton



// WEBPACK FOOTER //
// ./src/common/components/js/FICActionButton.js